
import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@/lib/utils";

export interface FAQItemProps {
  question: string;
  answer: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  variant?: "simple" | "card";
}

const FAQItem: React.FC<FAQItemProps> = ({ 
  question, 
  answer, 
  defaultOpen = false,
  className,
  variant = "simple"
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={cn(
      "border-b border-primary/10 pb-3 last:border-b-0", 
      variant === "card" && "p-4 rounded-lg",
      className
    )}>
      <button 
        className="flex items-center justify-between w-full text-left py-2 group"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <h3 className="font-medium">{question}</h3>
        {isOpen ? (
          <ChevronUp className="h-4 w-4 text-muted-foreground flex-shrink-0" />
        ) : (
          <ChevronDown className="h-4 w-4 text-muted-foreground flex-shrink-0" />
        )}
      </button>
      
      {isOpen && (
        <div className="pt-2 pb-3 text-sm text-muted-foreground">
          {answer}
        </div>
      )}
    </div>
  );
};

export default FAQItem;
